"use client";
export function saveToken(token: string) {
  localStorage.setItem("token", token);
}
export function getToken() {
  // Check if we are in a browser environment
  if (typeof window === "undefined") {
    return null; // Return null or a default value if running on the server
  }

  const token = localStorage.getItem("token");
  // console.log("token " + token);
  return token; // Return the token or null if not found
}

export function removeToken() {
  localStorage.removeItem("token");
}
